import ResizeObserver from 'resize-observer-polyfill'
if (typeof window !== 'undefined') {
  window.ResizeObserver = ResizeObserver
}
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
) 